<div class="admin-banner">
    <span>🚀 You are in <strong>System Admin Mode</strong></span>
    <button (click)="switchBack()" class="switch-btn">Switch Back</button>
</div>
  